import { render, staticRenderFns } from "./TwoStepInstructions.vue?vue&type=template&id=51b9e729&scoped=true"
import script from "./TwoStepInstructions.vue?vue&type=script&lang=js"
export * from "./TwoStepInstructions.vue?vue&type=script&lang=js"
import style0 from "./TwoStepInstructions.vue?vue&type=style&index=0&id=51b9e729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b9e729",
  null
  
)

export default component.exports